var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.name)?_c('div',{staticClass:"mb-1 text-xxs text-secondary"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('Table',{attrs:{"striped":"","borderless":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }